import { useApiQuery } from '~/hooks';
import { getCryptoBalancesApi, getCryptoBalanceStatsApi } from '../repository';

export const BALANCE_QUERY_KEYS = {
  BALANCES: 'crypto-balances',
  BALANCE_STATS: 'crypto-balance-stats',
};

/**
 * Query hook to fetch user's crypto balances
 * Returns available amounts tracked in the database
 */
export const useGetCryptoBalancesQuery = () => {
  return useApiQuery({
    queryKey: [BALANCE_QUERY_KEYS.BALANCES],
    queryFn: () => getCryptoBalancesApi(),
  });
};

/**
 * Query hook to fetch user's crypto balance statistics
 * Returns aggregated stats by currency
 */
export const useGetCryptoBalanceStatsQuery = () => {
  return useApiQuery({
    queryKey: [BALANCE_QUERY_KEYS.BALANCE_STATS],
    queryFn: () => getCryptoBalanceStatsApi(),
  });
};
